/**
 * LineItemIcon — 라인아이템(line item) 표시용 아이콘.
 *
 * `isExtendedTag` true 일 때는 확장 태그 변형(32px, 보라색 강조)을 렌더하고,
 * false 일 때는 기본 14px 라인 아이콘(currentColor)을 렌더한다.
 */

import { cn } from "@/lib/utils";

const ExtendedLineItemIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon bg-blue-100 rounded-[8px]"
    >
      <rect width="32" height="32" />
      <path
        d="M15.25 17.5H11.5C10.6716 17.5 10 18.1716 10 19V20.5C10 21.3284 10.6716 22 11.5 22H15.25C16.0784 22 16.75 21.3284 16.75 20.5V19C16.75 18.1716 16.0784 17.5 15.25 17.5Z"
        stroke="#9333EA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 10H11.5C10.6716 10 10 10.6716 10 11.5V13C10 13.8284 10.6716 14.5 11.5 14.5H20.5C21.3284 14.5 22 13.8284 22 13V11.5C22 10.6716 21.3284 10 20.5 10Z"
        stroke="#9333EA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_7546_25705)">
        <path
          d="M21.999 16.4375C22.1319 16.4375 22.2626 16.4698 22.3789 16.5312L22.4902 16.6025L22.5889 16.6904C22.6494 16.7542 22.6992 16.8275 22.7363 16.9072L22.7822 17.0312L22.7852 17.042L23.5752 20.1094C23.5947 20.185 23.6343 20.2543 23.6895 20.3096C23.7447 20.3648 23.814 20.4043 23.8896 20.4238L26.957 21.2148L26.9668 21.2168C27.138 21.2641 27.2888 21.3665 27.3965 21.5078C27.5042 21.6493 27.5625 21.8222 27.5625 22C27.5625 22.1778 27.5042 22.3507 27.3965 22.4922C27.2888 22.6335 27.138 22.7359 26.9668 22.7832L26.957 22.7861L23.8896 23.5762C23.814 23.5957 23.7447 23.6352 23.6895 23.6904C23.6481 23.7318 23.6157 23.7811 23.5938 23.835L23.5752 23.8906L22.7842 26.958L22.7812 26.9697C22.7334 27.1402 22.6313 27.2904 22.4902 27.3975C22.349 27.5046 22.1763 27.5625 21.999 27.5625C21.8217 27.5625 21.6491 27.5046 21.5078 27.3975C21.3666 27.2903 21.2646 27.1395 21.2168 26.9688L21.2139 26.958L20.4229 23.8906C20.4033 23.8149 20.3639 23.7457 20.3086 23.6904C20.2533 23.6352 20.184 23.5957 20.1084 23.5762L17.041 22.7852L17.0283 22.7822C16.8583 22.734 16.7082 22.6313 16.6016 22.4902C16.495 22.3492 16.4375 22.1768 16.4375 22C16.4375 21.8234 16.4952 21.6517 16.6016 21.5107L16.6895 21.4121C16.7845 21.3215 16.9007 21.255 17.0283 21.2188L17.041 21.2148L20.1084 20.4238C20.184 20.4043 20.2534 20.3647 20.3086 20.3096C20.3638 20.2544 20.4033 20.185 20.4229 20.1094L21.2139 17.042L21.2168 17.0312C21.2646 16.8605 21.3675 16.7097 21.5088 16.6025L21.6201 16.5312C21.7363 16.4699 21.8663 16.4376 21.999 16.4375Z"
          fill="#9333EA"
          stroke="#DBEAFE"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7546_25705">
          <rect width="12" height="12" transform="translate(16 16)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LineItemIcon = ({
  isExtendedTag,
  className,
}: {
  isExtendedTag: boolean;
  className?: string;
}) => {
  if (isExtendedTag) {
    return <ExtendedLineItemIcon />;
  }

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("svg-icon", className)}
    >
      <path
        d="M7.25 9.5H3.5C2.67157 9.5 2 10.1716 2 11V12.5C2 13.3284 2.67157 14 3.5 14H7.25C8.07843 14 8.75 13.3284 8.75 12.5V11C8.75 10.1716 8.07843 9.5 7.25 9.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 2H3.5C2.67157 2 2 2.67157 2 3.5V5C2 5.82843 2.67157 6.5 3.5 6.5H12.5C13.3284 6.5 14 5.82843 14 5V3.5C14 2.67157 13.3284 2 12.5 2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
